import React from "react";
const Dashboard = React.lazy(() => import("./containers/DashboardContainer"));
const Login = React.lazy(() => import("./containers/LoginContainer"));

const Residents = React.lazy(() => import("./containers/ResidentsContainer"));

const Alerts_B = React.lazy(() => import("./containers/Alert_BContainer"));

const Purchases = React.lazy(() => import("./containers/PurchaseContainer"));
const Support = React.lazy(() => import("./containers/SupportCondainer"));

const ApprovedResidents = React.lazy(() =>
  import("./containers/ApprovedResidentsContainer")
);
const Onboarding1 = React.lazy(() => import("./screens/Onboarding1"));
const onboardingResidents = React.lazy(() =>
  import("./containers/Onboarding_residentsContainer")
);
const onboarding2 = React.lazy(() =>
  import("./containers/Onboarding2Container")
);

const Myprofile = React.lazy(() => import("./containers/MyprofileContainer"));

const Apartments = React.lazy(() => import("./containers/ApartmentContainer"));
// const CustomerCredit = React.lazy(() =>
//   import("./screens/Customers/Components/customerCredit")
// );

// const Consumption = React.lazy(() =>
//   import("./containers/ConsumptionContainer")
// );
const Rwamembers = React.lazy(() => import("./containers/RwaContainer"));

const Invoice = React.lazy(() => import("./containers/InvoiceContainer"));
const Settings = React.lazy(() => import("./containers/SettingsContainer"));
// const InvioceView = React.lazy(() => import("./screens/Invoice/InvioceView"));

const routes = [
  // { path: '/', exact: true, name: 'Home' },
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  { path: "/login", name: "Login", component: Login },

  {
    path: "/alerts",
    name: "Alerts_B",
    component: Alerts_B,
  },
  {
    path: "/residents",
    name: "Residents",
    component: Residents,
  },

  {
    path: "/support",
    name: "Support",
    component: Support,
  },
  {
    path: "/purchases",
    name: "Purchase",
    component: Purchases,
  },

  {
    path: "/ApprovedResidents",
    name: "Approved Residents",
    component: ApprovedResidents,
  },
  { path: "/Onboarding1", name: "Onboarding 1", component: Onboarding1 },
  {
    path: "/onboardingResidents",
    name: "onboardingResidents",
    component: onboardingResidents,
  },
  {
    path: "/onboarding2",
    name: "onboarding2",
    component: onboarding2,
  },
  {
    path: "/myprofile",
    name: "Myprofile",
    component: Myprofile,
  },
  {
    path: "/apartments",
    name: "Apartments",
    component: Apartments,
  },
  // {
  //   path: "/consumption",
  //   name: "consumption",
  //   component: Consumption,
  // },
  {
    path: "/rwamembers",
    name: "Rwamembers",
    component: Rwamembers,
  },

  {
    path: "/settings",
    name: "Settings",
    component: Settings,
  },
  {
    path: "/invoice",
    name: "Invoice",
    component: Invoice,
    exact: true,
  },
  {
    path: "/invoice/:id",
    name: "Invoice",
    component: Invoice,
    exact: true,
  },
];

export default routes;
